import {Component, Input, OnInit} from '@angular/core';


@Component({
    selector: 'aw-validation-error-list',
    templateUrl: './validation-error-list.component.html',
    styleUrls: ['./validation-error-list.component.less'],
    imports: []
})
export class ValidationErrorListComponent implements OnInit {
  @Input() item: any;
  constructor() { }

  ngOnInit() {
  }

}
